var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"filters--sort"},[_c('span',{staticClass:"filters--sort__label"},[_vm._v("Sort by")]),_vm._v(" "),_c('div',{staticClass:"filters--sort__control"},[_c('Survey',{attrs:{"survey":_vm.survey}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }